<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Editar OS {{ item.codigoOs }}
  </div>
</div>

<div class="modal-body">
<div class="info-os-panel mb-4">
  <div class="info-os-row">
    <mat-icon>groups</mat-icon>
    <span><span class="info-os-label">PAX:</span> {{ paxDisplay }}</span>
  </div>
  <div class="info-os-row">
    <mat-icon>location_on</mat-icon>
    <span><span class="info-os-label">Endereço completo:</span> {{ enderecoCompletoDisplay }}</span>
  </div>
  <div class="info-os-row">
    <mat-icon>schedule</mat-icon>
    <span><span class="info-os-label">Período:</span> {{ periodoDisplay }}</span>
  </div>
</div>

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <div [formGroup]="form">
    <div [formGroup]="supplierFilterForm" class="mb-2 flex justify-between items-center gap-3">
      <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
        <mat-label>Filtrar por nome</mat-label>
        <input matInput formControlName="nome" />
      </mat-form-field>
      <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
        <mat-label>Filtrar por CNPJ</mat-label>
        <input matInput formControlName="cnpj" />
      </mat-form-field>
      <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
        <mat-label>Filtrar por cidade</mat-label>
        <input matInput formControlName="cidade" />
      </mat-form-field>
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-6/12"
        appearance="outline"
      >
        <mat-label>Fornecedor</mat-label>
        <mat-select formControlName="fornecedorId">
          @for (supplier of suppliers; track supplier.id) {
            <mat-option [value]="supplier.id">
              {{ supplier.nomeFantasia ?? supplier.nome ?? supplier.razaoSocial }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Valor tarifário</mat-label>
        <input
          matInput
          [value]="cos?.valorTarifario ?? '-'"
          readonly
        />
      </mat-form-field>

      @if (isGestor) {
        <mat-form-field
          class="input-tg search-tg no-message-new w-3/12"
          appearance="outline"
        >
          <mat-label>Prazo de pagamento (dias)</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="prazoEdit"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
        <button
          mat-flat-button
          class="btn-tg"
          type="button"
          [disabled]="savingPrazo"
          (click)="salvarPrazo()"
        >
          @if (savingPrazo) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Salvar prazo
          }
        </button>
      } @else {
        <mat-form-field
          class="input-tg search-tg no-message-new w-3/12"
          appearance="outline"
        >
          <mat-label>Prazo de pagamento</mat-label>
          <input
            matInput
            [value]="
              prazoPagamentoSelecionado != null
                ? prazoPagamentoSelecionado + ' dias'
                : '-'
            "
            readonly
          />
        </mat-form-field>
      }
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Tipo de veículo</mat-label>
        <input
          matInput
          [value]="item.descricaoTipoVeiculo ?? '-'"
          readonly
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Tipo de motorista</mat-label>
        <input
          matInput
          [value]="item.descricaoTipoMotorista ?? '-'"
          readonly
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Status da compra</mat-label>
        <input
          matInput
          [value]="cos?.descricaoStatusCompra ?? '-'"
          readonly
        />
      </mat-form-field>
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Valor de compra</mat-label>
        <input matInput currencyInput formControlName="valorCompra" />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Valor motorista (freelancer)</mat-label>
        <input matInput currencyInput formControlName="valorMotorista" />
      </mat-form-field>

      <div class="w-4/12">
        <mat-checkbox formControlName="freelancer"
          >Motorista freelancer (cobrado à parte)</mat-checkbox
        >
      </div>
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Venda sem taxa</mat-label>
        <input matInput [value]="vendaSemTaxaDisplay" readonly />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Multiplicador venda</mat-label>
        <input
          matInput
          type="number"
          step="0.01"
          formControlName="multiplicadorVenda"
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Target</mat-label>
        <input matInput [value]="targetDisplay" readonly />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Savings</mat-label>
        <input matInput [value]="savingsDisplay" readonly />
      </mat-form-field>
    </div>

    <div class="mb-3 -mt-2">
      @if (multiplicadorTravado) {
        <p class="text-xs text-gray-500">
          Multiplicador fixo em 0,55 (divisor da proposta ausente ou ≥ 0,55).
        </p>
      } @else if (!isGestor) {
        <p class="text-xs text-gray-500">
          Somente o Gestor de Reserva/Compras pode alterar o multiplicador.
        </p>
      }
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-6/12"
        appearance="outline"
      >
        <mat-label>Observação O.S.</mat-label>
        <textarea matInput formControlName="observacaoOs"></textarea>
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-6/12"
        appearance="outline"
      >
        <mat-label>Observação ao fornecedor</mat-label>
        <textarea matInput formControlName="obsFornecedorOperador"></textarea>
      </mat-form-field>
    </div>

    <mat-accordion class="mb-3 block">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Histórico de Valores Cotados </mat-panel-title>
        </mat-expansion-panel-header>

        @if (loadingPrecificacoes) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        } @else if (precificacoes.length) {
          <div class="tab-overflow">
            <table
              mat-table
              [dataSource]="precificacoes"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="fornecedor">
                <th mat-header-cell *matHeaderCellDef>Fornecedor</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.fornecedorNome }}
                </td>
              </ng-container>

              <ng-container matColumnDef="cnpj">
                <th mat-header-cell *matHeaderCellDef>CNPJ</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.fornecedorDocumento | cnpj }}
                </td>
              </ng-container>

              <ng-container matColumnDef="custo">
                <th mat-header-cell *matHeaderCellDef>Custo</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.custoFormatado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="custoHoraExtra">
                <th mat-header-cell *matHeaderCellDef>Custo hora extra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.custoHoraExtraFormatado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="custoKmExtra">
                <th mat-header-cell *matHeaderCellDef>Custo KM extra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.custoKmExtraFormatado }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                class="style-header"
                *matHeaderRowDef="displayedColumnsPrecificacao"
              ></tr>
              <tr
                mat-row
                class="style-row"
                *matRowDef="let row; columns: displayedColumnsPrecificacao"
              ></tr>
            </table>
          </div>
        } @else {
          <p class="text-xs text-gray-500">Nenhum valor cotado para esta OS.</p>
        }
      </mat-expansion-panel>
    </mat-accordion>

  </div>
}
</div>

<div class="modal-footer flex justify-end items-center gap-2">
  <button mat-flat-button class="btn-tg-white" (click)="close()" [disabled]="saving">
    Cancelar
  </button>
  <button mat-flat-button class="btn-tg" (click)="save()" [disabled]="saving || loading">
    @if (saving) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Salvar
    }
  </button>
</div>
